import React from 'react';

const PageLoader: React.FC = () => (
  <div className="flex min-h-[240px] items-center justify-center">
    <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-primary" />
  </div>
);

export default PageLoader;
